import React from "react"
import { ReportAPI } from "../../lib/utils"
import ReportForm from "./ReportForm"

export default function GeneralLedgerReport() {
  return <ReportForm reportAPI={ ReportAPI.GENERAL_LEDGER } />
}


// WEBPACK FOOTER //
// ./src/components/Reports/GeneralLedgerReport.js